module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n        <div class=\"row form-group text-center\">\r\n            <span>Are you sure you want to delete Job</span>\r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-cron/insa-job/insa-job-form/delete-job.component.html
// module id = 1763
// module chunks = 2